// @ts-nocheck
import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import {useBody} from "../Body/state/BodyContext";

export default function BackdropGeneral() {
    const {loadingBackdrop , setLoadingBackdrop} = useBody();
    const handleClose = () => {
        setLoadingBackdrop(false);
    };

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => 1301 }}
                open={loadingBackdrop}
                onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}